import { configureStore } from "@reduxjs/toolkit";
import { areaApi } from "./APIs/areaApi";
import { binApi } from "./APIs/binApi";

export const store = configureStore({
  reducer: {
    [areaApi.reducerPath]: areaApi.reducer,
    [binApi.reducerPath]: binApi.reducer,
    // [authApi.reducerPath]: authApi.reducer,
  },
  // Cache, Polling , invalidate cache
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      areaApi.middleware,
      binApi.middleware
      // authApi.middleware,
    ),
});
